import { Location } from '@cobliteam/common-types';
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useOverlayMediaStore from '../store/useOverlayMediaStore';

const toSnakeCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

const useOnNavigate = () => {
  const history = useHistory();
  const setOverlayMediaId = useOverlayMediaStore((s) => s.setMediaId);
  const clearOverlay = useOverlayMediaStore((s) => s.clear);

  useEffect(() => {
    return history.listen(() => clearOverlay());
  }, [history, clearOverlay]);

  return useCallback(
    (path: string, params?: Record<string, unknown>, options?: { target?: string }) => {
      // Intercepts CAMERA_EVENTS location to display a DialogMedia instead
      // of navigating to a new page
      if (path === Location.CAMERA_EVENTS && params?.mediaId) {
        setOverlayMediaId(String(params.mediaId));
        return;
      }

      const isExternalTarget = options?.target === '_blank';

      const searchParams = new URLSearchParams();
      if (params) {
        for (const [key, value] of Object.entries(params)) {
          if (value !== undefined && value !== null) {
            const paramKey = isExternalTarget ? toSnakeCase(key) : key;
            searchParams.append(paramKey, String(value));
          }
        }
      }

      const qs = searchParams.toString();
      const fullPath = qs ? `${path}?${qs}` : path;

      if (isExternalTarget) {
        window.open(fullPath, '_blank', 'noopener,noreferrer');
      } else {
        history.push(fullPath);
      }
    },
    [history, setOverlayMediaId]
  );
};

export default useOnNavigate;
